<template>
<div
  id="dashboard"
>
  <h3
    class="alert alert-info"
  >
    Hello, {{ this.$parent.currentUser.name }}
  </h3>

  <div
    id="dashboard-cont"
    class="row"
  >
    <div
      class="col dashboard-block"
    >
      <span>
        <router-link
          :to="{
            name: 'newsletters'
          }"
        >
          {{ pending_newsletters }}
        </router-link>
      </span>

      <p>
        Pending Newsletters
      </p>

      <span
        class="dashboard-block-from"
      >
        {{ since_at }}
      </span>
    </div>

    <div
      class="col dashboard-block"
    >
      <span>
        <router-link
          :to="{
            name: 'subscriptions'
          }"
        >
          {{ subscriptions }}
        </router-link>
      </span>

      <p>
        Subscriptions
      </p>

      <span
        class="dashboard-block-from"
      >
        {{ since_at }}
      </span>
    </div>
  </div>
</div>
</template>

<script>
export default {
  data () {
    return {
      pending_newsletters: undefined,
      since_at: undefined,
      subscriptions: undefined
    }
  },

  components: {
  },

  created () {
    this.get()
  },

  methods: {
    get () {
      return this.$http.get(
        this.apiUrl('/dashboard', true)
      ).then((resp) => {
        Object.keys(resp.body.data).forEach((key) => {
          this[key] = resp.body.data[key]
        })
      })
    }
  }
}
</script>
<style>
  .dashboard-block {
    border: solid 3px #ccc;
    margin: 0 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue